/** Built-in asset columns — always shown in table (in this order), then API-defined extras. */
export const DEFAULT_ASSET_FIELDS = [
  { key: 'laptop', label: 'Laptop' },
  { key: 'monitor', label: 'Monitor' },
  { key: 'keyboard', label: 'Keyboard' },
  { key: 'mouse', label: 'Mouse' },
  { key: 'charger', label: 'Charger' },
  { key: 'hdmi', label: 'HDMI' },
  { key: 'stand', label: 'Stand' },
  { key: 'extensionBoard', label: 'Extension Board' },
  { key: 'extraAccessories', label: 'Extra Accessories' }
];

export const DEFAULT_ASSET_FIELD_KEYS = new Set(DEFAULT_ASSET_FIELDS.map((f) => f.key));

export function mergeAssetFields(apiFields = []) {
  const apiByKey = new Map();
  apiFields.forEach((f) => {
    if (f?.key) apiByKey.set(f.key, f);
  });

  const merged = DEFAULT_ASSET_FIELDS.map((def) => {
    const api = apiByKey.get(def.key);
    if (api) {
      return {
        id: api.id,
        key: api.key,
        label: api.label || def.label,
        isRequired: !!api.isRequired
      };
    }
    return { id: null, key: def.key, label: def.label, isRequired: false };
  });

  apiFields.forEach((f) => {
    if (f?.key && !DEFAULT_ASSET_FIELD_KEYS.has(f.key)) {
      merged.push(f);
    }
  });

  return merged;
}
